import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CallbackService } from '@callback/data-access';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { ButtonSizes } from '@shared/v2/models';

@Component({
  selector: 'sd-error-msg',
  templateUrl: './error-msg.component.html',
  styleUrls: ['form-state-messages.scss'],
  imports: [SdvorButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMsgComponent {
  buttonSize = ButtonSizes;

  constructor(private callbackService: CallbackService) {}

  tryAgain(): void {
    this.callbackService.resetProcess();
  }
}
